import React from 'react';
import { Box, Button, DialogContent, Grid } from '@material-ui/core';

const ConfirmacionEnvio = props => {
  const { onCloseDialog, nFolioDoc } = props;
  return (
    <DialogContent dividers>
      <Box
        sx={{
          width: '100%',
          minHeight: 350,
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'center',
        }}>
        <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>
          <Grid item xs={12} style={{ textAlign: 'center' }}>
            <p style={{ fontSize: 24 }}>
              Hemos recibido su archivo adjunto con N° Folio {nFolioDoc}. Puede consultar su estado en la sección Historia
            </p>
          </Grid>
        </Box>
      </Box>
      <Box display="flex" justifyContent="flex-end" mb={4}>
        <Button variant="outlined" color="primary" onClick={onCloseDialog}>
          &nbsp;Cerrar&nbsp;
        </Button>
      </Box>
    </DialogContent>
  );
};

export default ConfirmacionEnvio;
